 <!--
 2019-2-13, AJK, created file
 2019-2-14, AJK, updated to use reusable password form component
 -->


<template>
  <change-password-form :passwordChangeNeeded="true"/>
</template>

<script>
  // // @ is an alias to /src
  import ChangePasswordForm from '@/components/ChangePasswordForm.vue'
  
  export default {
    components:{
      'change-password-form' : ChangePasswordForm
    },
    name: 'changePassword',
    props: ['existingPassword'],
    data () {
      return {
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>